/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Searchplaceholder1Inputs */

const id_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari jalur lengkap…`)
};

const ms_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari laluan penuh…`)
};

const da_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg i hele stien…`)
};

const de_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständigen Pfad durchsuchen…`)
};

const en_us2_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the full path…`)
};

const es_es2_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar la ruta completa…`)
};

const es_mx2_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar la ruta completa…`)
};

const fil_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap sa buong path…`)
};

const fr_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher le chemin complet…`)
};

const it_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca nel percorso completo…`)
};

const hu_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés a teljes útvonalon…`)
};

const nl_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig pad doorzoeken…`)
};

const no_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk i hele banen…`)
};

const pl_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj w pełnej ścieżce…`)
};

const pt_br2_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar o caminho completo…`)
};

const pt_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar o caminho completo…`)
};

const ro_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută în calea completă…`)
};

const fi_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae koko polusta…`)
};

const sv_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök i hela sökvägen…`)
};

const vi_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm đường dẫn đầy đủ…`)
};

const tr_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam yolda ara…`)
};

const cs_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat v celé cestě…`)
};

const bg_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене в пълния път…`)
};

const ru_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск по полному пути…`)
};

const uk_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук за повним шляхом…`)
};

const ar_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث في المسار الكامل…`)
};

const hi_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा पाथ खोजें…`)
};

const th_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาเส้นทางแบบเต็ม…`)
};

const ja_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルパスを検索…`)
};

const zh_cn2_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索完整路径…`)
};

const zh_hant1_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋完整路徑…`)
};

const ko_builds_comparison_searchplaceholder1 = /** @type {(inputs: Builds_Comparison_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 경로 검색…`)
};

/**
* | output |
* | --- |
* | "Search the full path…" |
*
* @param {Builds_Comparison_Searchplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_searchplaceholder1 = /** @type {((inputs?: Builds_Comparison_Searchplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Searchplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_searchplaceholder1(inputs)
	if (locale === "ms") return ms_builds_comparison_searchplaceholder1(inputs)
	if (locale === "da") return da_builds_comparison_searchplaceholder1(inputs)
	if (locale === "de") return de_builds_comparison_searchplaceholder1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_searchplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_searchplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_searchplaceholder1(inputs)
	if (locale === "fil") return fil_builds_comparison_searchplaceholder1(inputs)
	if (locale === "fr") return fr_builds_comparison_searchplaceholder1(inputs)
	if (locale === "it") return it_builds_comparison_searchplaceholder1(inputs)
	if (locale === "hu") return hu_builds_comparison_searchplaceholder1(inputs)
	if (locale === "nl") return nl_builds_comparison_searchplaceholder1(inputs)
	if (locale === "no") return no_builds_comparison_searchplaceholder1(inputs)
	if (locale === "pl") return pl_builds_comparison_searchplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_searchplaceholder1(inputs)
	if (locale === "pt") return pt_builds_comparison_searchplaceholder1(inputs)
	if (locale === "ro") return ro_builds_comparison_searchplaceholder1(inputs)
	if (locale === "fi") return fi_builds_comparison_searchplaceholder1(inputs)
	if (locale === "sv") return sv_builds_comparison_searchplaceholder1(inputs)
	if (locale === "vi") return vi_builds_comparison_searchplaceholder1(inputs)
	if (locale === "tr") return tr_builds_comparison_searchplaceholder1(inputs)
	if (locale === "cs") return cs_builds_comparison_searchplaceholder1(inputs)
	if (locale === "bg") return bg_builds_comparison_searchplaceholder1(inputs)
	if (locale === "ru") return ru_builds_comparison_searchplaceholder1(inputs)
	if (locale === "uk") return uk_builds_comparison_searchplaceholder1(inputs)
	if (locale === "ar") return ar_builds_comparison_searchplaceholder1(inputs)
	if (locale === "hi") return hi_builds_comparison_searchplaceholder1(inputs)
	if (locale === "th") return th_builds_comparison_searchplaceholder1(inputs)
	if (locale === "ja") return ja_builds_comparison_searchplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_searchplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_searchplaceholder1(inputs)
	return ko_builds_comparison_searchplaceholder1(inputs)
});
export { builds_comparison_searchplaceholder1 as "builds.comparison.searchPlaceholder" }